import axios from 'axios';

export function isNotFoundError(caughtError: unknown): boolean {
  return (
    axios.isAxiosError(caughtError) === true &&
    caughtError.response !== undefined &&
    caughtError.response.status === 404
  );
}
